/* FER — globale Interaktivität. Kein Build-Step, reines Vanilla-JS. */
(function () {
  "use strict";

  /* ---------- Reveal-on-scroll ---------- */
  var reveals = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-shown");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    reveals.forEach(function (el) {
      io.observe(el);
    });
  } else {
    reveals.forEach(function (el) {
      el.classList.add("is-shown");
    });
  }

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector(".site-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Fullscreen nav ---------- */
  var navOverlay = document.querySelector("[data-nav-overlay]");
  var navOpenBtn = document.querySelector("[data-nav-open]");
  var navCloseBtn = document.querySelector("[data-nav-close]");
  function setNav(open) {
    if (!navOverlay) return;
    navOverlay.classList.toggle("is-open", open);
    navOverlay.setAttribute("aria-hidden", open ? "false" : "true");
    document.body.style.overflow = open ? "hidden" : "";
  }
  if (navOpenBtn) navOpenBtn.addEventListener("click", function () { setNav(true); });
  if (navCloseBtn) navCloseBtn.addEventListener("click", function () { setNav(false); });
  document.querySelectorAll("[data-nav-overlay] a").forEach(function (a) {
    a.addEventListener("click", function () { setNav(false); });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector("[data-cart-drawer]");
  var cartOpenBtns = document.querySelectorAll("[data-cart-open]");
  var cartCloseBtns = document.querySelectorAll("[data-cart-close]");

  /* ---------- Pfand im Abo (siehe snippets/fer-pfand-config.liquid) ---------- */
  var PF = window.FER_PFAND || null;
  function pfandActive() {
    return !!(PF && PF.variantId && PF.plans && Object.keys(PF.plans).length);
  }
  function intervalKey(item) {
    var sp = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    var m = sp && sp.name && sp.name.match(/(\d+)\s*woche/i);
    return m ? m[1] : null;
  }
  function cansOf(item) {
    var c = parseInt(item.variant_title, 10);
    if (isNaN(c) || c < 1) c = 1;
    return c * item.quantity;
  }
  function isPfandLine(item) {
    return !!(PF && item.variant_id === PF.variantId);
  }
  /* Abo-Position, deren Pfand als eigene Abo-Pfand-Position läuft */
  function hasAboPfandLine(item) {
    var k = intervalKey(item);
    return !!(item.selling_plan_allocation && k && pfandActive() && PF.plans[k]);
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  var pfandSyncing = false;
  function syncAboPfand(cart) {
    if (!pfandActive() || pfandSyncing) return Promise.resolve({ cart: cart, changed: false });
    var need = {};
    cart.items.forEach(function (it) {
      if (isPfandLine(it) || !hasAboPfandLine(it)) return;
      var k = intervalKey(it);
      need[k] = (need[k] || 0) + cansOf(it);
    });
    var have = {};
    var ops = [];
    cart.items.forEach(function (it) {
      if (!isPfandLine(it) || !it.selling_plan_allocation) return; /* Einmal-Pfand regelt BB Pfand */
      var k = intervalKey(it);
      if (!k || !need[k] || have[k] !== undefined) {
        ops.push({ id: it.key, quantity: 0 });
        return;
      }
      have[k] = it.quantity;
      if (it.quantity !== need[k]) ops.push({ id: it.key, quantity: need[k] });
    });
    var adds = [];
    Object.keys(need).forEach(function (k) {
      if (have[k] === undefined) adds.push({ id: PF.variantId, quantity: need[k], selling_plan: PF.plans[k] });
    });
    if (!ops.length && !adds.length) return Promise.resolve({ cart: cart, changed: false });
    pfandSyncing = true;
    var chain = Promise.resolve();
    ops.forEach(function (op) {
      chain = chain.then(function () { return postJSON("/cart/change.js", op); });
    });
    if (adds.length) {
      chain = chain.then(function () { return postJSON("/cart/add.js", { items: adds }); });
    }
    return chain
      .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
      .then(
        function (c) { pfandSyncing = false; return { cart: c, changed: true }; },
        function (e) { pfandSyncing = false; throw e; }
      );
  }
  var cartPage = document.querySelector("[data-cart-page]");
  function syncAndRender(cart) {
    return syncAboPfand(cart).then(function (res) {
      if (res.changed && cartPage) {
        window.location.reload();
        return res.cart;
      }
      renderCart(res.cart);
      return res.cart;
    }, function () {
      renderCart(cart);
      return cart;
    });
  }

  function renderCart(cart) {
    if (!drawer) return;
    var itemsEl = drawer.querySelector("[data-cart-items]");
    var totalEl = drawer.querySelector("[data-cart-total]");
    var countEls = document.querySelectorAll("[data-cart-count]");
    var count = cart.items.reduce(function (n, it) { return isPfandLine(it) ? n : n + it.quantity; }, 0);
    countEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "flex" : "none";
    });
    if (totalEl) {
      /* Nur noch für Abos ohne eigene Pfand-Position wird der Pfand rein optisch addiert */
      var aboPfandCents = cart.items.reduce(function (sum, it) {
        if (!it.selling_plan_allocation || isPfandLine(it) || hasAboPfandLine(it)) return sum;
        return sum + cansOf(it) * 25;
      }, 0);
      totalEl.textContent = formatMoney(cart.total_price + aboPfandCents);
    }
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="muted">Dein Warenkorb ist noch leer.</p>';
      return;
    }
    itemsEl.innerHTML = cart.items
      .map(function (item) {
        if (isPfandLine(item)) {
          return (
            '<div class="cart-line cart-line--pfand" data-key="' + item.key + '">' +
            '<div class="cart-line__info"><p class="cart-line__title">Einwegpfand im Abo</p>' +
            '<p class="muted">' + item.quantity + " × 0,25 €</p>" +
            (item.selling_plan_allocation ? '<p class="muted" style="font-size:0.8125rem">' + item.selling_plan_allocation.selling_plan.name + "</p>" : "") +
            "<p>" + formatMoney(item.final_line_price) + "</p></div></div>"
          );
        }
        var pfandCents = cansOf(item) * 25;
        var priceExPfand = item.selling_plan_allocation ? item.final_line_price : item.final_line_price - pfandCents;
        return (
          '<div class="cart-line" data-key="' +
          item.key +
          '">' +
          (item.image ? '<img src="' + item.image + '" alt="" width="64" height="64" style="object-fit:contain;border-radius:4px">' : "") +
          '<div class="cart-line__info"><p class="cart-line__title">' +
          item.product_title +
          "</p><p class=\"muted\">" +
          item.variant_title +
          " · " +
          item.quantity +
          "x</p>" +
          (item.selling_plan_allocation ? '<p class="muted" style="font-size:0.8125rem">' + item.selling_plan_allocation.selling_plan.name + "</p>" : "") +
          "<p>" +
          formatMoney(priceExPfand) +
          '</p><p class="muted" style="font-size:0.75rem">zzgl. ' +
          formatMoney(pfandCents) +
          ' Pfand</p><button type="button" class="pill" data-cart-remove data-key="' +
          item.key +
          '">Entfernen</button></div></div>'
        );
      })
      .join("");
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString("de-DE", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR" });
  }

  function fetchCart() {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(syncAndRender)
      .catch(function () {});
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    fetchCart();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
  }
  cartOpenBtns.forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); }); });
  cartCloseBtns.forEach(function (b) { b.addEventListener("click", closeDrawer); });

  document.addEventListener("click", function (e) {
    var removeBtn = e.target.closest("[data-cart-remove]");
    if (!removeBtn) return;
    var key = removeBtn.getAttribute("data-key");
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then(function (r) { return r.json(); })
      .then(syncAndRender);
  });

  /* Warenkorbseite: vor dem Checkout Mengen speichern und Abo-Pfand angleichen */
  if (cartPage) {
    var cartForm = cartPage.querySelector("form");
    if (cartForm) {
      cartForm.addEventListener("submit", function (e) {
        var submitter = e.submitter;
        if (!submitter || submitter.name !== "checkout" || !pfandActive()) return;
        e.preventDefault();
        submitter.disabled = true;
        var body = new URLSearchParams(new FormData(cartForm));
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" },
          body: body.toString(),
        })
          .then(function (r) { return r.json(); })
          .then(syncAboPfand)
          .then(function () { window.location.href = "/checkout"; })
          .catch(function () { window.location.href = "/checkout"; });
      });
    }
  }

  window.FER = window.FER || {};
  window.FER.syncAboPfand = syncAboPfand;
  window.FER.refreshCart = fetchCart;

  window.FER = window.FER || {};
  window.FER.addToCart = function (items, opts) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        openDrawer();
        return true;
      })
      .catch(function (err) {
        if (opts && opts.onError) opts.onError(err);
        return false;
      });
  };

  fetchCart();

  /* ---------- Fermentation timeline (scroll-linked, progressive enhancement) ---------- */
  document.querySelectorAll("[data-timeline]").forEach(function (wrap) {
    var steps = wrap.querySelectorAll(".timeline__step");
    steps.forEach(function (step, i) {
      step.querySelector("summary").addEventListener("click", function (e) {
        e.preventDefault();
        var isOpen = step.hasAttribute("open");
        steps.forEach(function (s) { s.removeAttribute("open"); });
        if (!isOpen) step.setAttribute("open", "");
      });
    });
    if (steps.length) steps[0].setAttribute("open", "");
  });

  /* ---------- Store locator filter ---------- */
  document.querySelectorAll("[data-locator]").forEach(function (locator) {
    var filterBtns = locator.querySelectorAll("[data-filter]");
    var cards = locator.querySelectorAll("[data-location-card]");
    var searchForm = locator.querySelector("[data-locator-search]");
    var cityLabel = locator.querySelector("[data-locator-city]");
    var resultCount = locator.querySelector("[data-locator-count]");
    var notFoundBox = locator.querySelector("[data-locator-notfound]");
    var activeFilter = "alle";

    function applyFilter() {
      var visible = 0;
      cards.forEach(function (card) {
        var cat = card.getAttribute("data-category");
        var show = activeFilter === "alle" || cat === activeFilter;
        card.style.display = show ? "" : "none";
        if (show) visible++;
      });
      if (resultCount) resultCount.textContent = visible + (visible === 1 ? " Ergebnis" : " Ergebnisse");
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        activeFilter = btn.getAttribute("data-filter");
        filterBtns.forEach(function (b) { b.classList.toggle("is-active", b === btn); b.setAttribute("aria-pressed", b === btn); });
        applyFilter();
      });
    });

    if (searchForm) {
      searchForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var value = searchForm.querySelector("input").value.trim().toLowerCase();
        var known = Array.prototype.some.call(cards, function (c) {
          return (c.getAttribute("data-city") || "").toLowerCase() === value;
        });
        if (value === "" || known) {
          if (notFoundBox) notFoundBox.hidden = true;
          if (value !== "" && cityLabel) cityLabel.textContent = value;
        } else if (notFoundBox) {
          notFoundBox.hidden = false;
          notFoundBox.querySelector("[data-notfound-city]").textContent = searchForm.querySelector("input").value.trim();
        }
      });
    }

    applyFilter();
  });

  document.addEventListener("click", function (e) {
    var wishBtn = e.target.closest("[data-locator-wish]");
    if (!wishBtn) return;
    var msg = wishBtn.parentElement.querySelector("[data-locator-wish-msg]");
    if (msg) msg.hidden = false;
  });

  /* ---------- Buy section (flavor / mode / quantity / subscription) ---------- */
  document.querySelectorAll("[data-buy-section]").forEach(function (section) {
    var flavorInputs = section.querySelectorAll('input[name="fer-flavor"]');
    var modeInputs = section.querySelectorAll('input[name="fer-mode"]');
    var qtyInputs = section.querySelectorAll('input[name="fer-qty"]');
    var planInputs = section.querySelectorAll('input[name="fer-plan"]');
    var freqInputs = section.querySelectorAll('input[name="fer-freq"]');
    var panel = section.querySelector("[data-buy-panel]");
    var steps = section.querySelector("[data-buy-steps]");
    var qtyStep = section.querySelector("[data-step-qty]");
    var subStep = section.querySelector("[data-step-sub]");
    var addBtn = section.querySelector("[data-buy-add]");
    var modeBtns = section.querySelectorAll("[data-mode-btn]");
    var accentMap = {};
    try {
      accentMap = JSON.parse(section.getAttribute("data-flavor-accent-map") || "{}");
    } catch (e) {
      accentMap = {};
    }

    function state() {
      var flavor = section.querySelector('input[name="fer-flavor"]:checked');
      var mode = section.querySelector('input[name="fer-mode"]:checked');
      var qty = section.querySelector('input[name="fer-qty"]:checked');
      var plan = section.querySelector('input[name="fer-plan"]:checked');
      return {
        flavor: flavor ? flavor.value : null,
        mode: mode ? mode.value : "einmalig",
        qty: qty ? qty.value : null,
        plan: plan ? plan.value : null,
      };
    }

    function refresh() {
      var s = state();
      if (panel) {
        var accent = s.flavor && accentMap[s.flavor];
        panel.classList.toggle("has-flavor", Boolean(accent));
        if (accent) {
          panel.style.setProperty("--flavor-accent", accent);
          panel.style.setProperty("--flavor-surface", "color-mix(in oklab, " + accent + " 16%, var(--card))");
          panel.style.setProperty("--flavor-border", "color-mix(in oklab, " + accent + " 42%, var(--border))");
        }
      }
      if (steps) steps.classList.toggle("is-disabled", !s.flavor);
      if (qtyStep) qtyStep.hidden = s.mode !== "einmalig";
      if (subStep) subStep.hidden = s.mode !== "abo";
      modeBtns.forEach(function (b) {
        b.setAttribute("aria-pressed", b.getAttribute("data-mode-btn") === s.mode ? "true" : "false");
      });
      var canAdd = s.flavor && (s.mode === "einmalig" ? s.qty : s.plan);
      if (addBtn) addBtn.disabled = !canAdd;
    }

    modeBtns.forEach(function (b) {
      b.addEventListener("click", function () {
        section.querySelectorAll('input[name="fer-mode"]').forEach(function (i) {
          i.checked = i.value === b.getAttribute("data-mode-btn");
        });
        refresh();
      });
    });

    [].concat(
      Array.prototype.slice.call(flavorInputs),
      Array.prototype.slice.call(qtyInputs),
      Array.prototype.slice.call(planInputs),
      Array.prototype.slice.call(freqInputs)
    ).forEach(function (input) {
      input.addEventListener("change", refresh);
    });

    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var s = state();
        var variantMap = JSON.parse(section.getAttribute("data-variant-map") || "{}");
        var qtyValue = s.mode === "einmalig" ? s.qty : s.plan;
        var key = s.flavor + ":qty:" + qtyValue;
        var entry = variantMap[key];
        if (!entry) {
          window.alert("Diese Variante ist im Shop noch nicht hinterlegt. Bitte im Theme-Editor die Produkte verknüpfen.");
          return;
        }
        var payload = { id: entry.variant_id, quantity: 1 };
        if (s.mode === "abo") {
          var freq = section.querySelector('input[name="fer-freq"]:checked');
          var freqValue = freq ? freq.value : null;
          var planId = entry.selling_plans && freqValue ? entry.selling_plans[freqValue] : null;
          if (!planId) {
            window.alert("Für diesen Liefer-Rhythmus ist noch kein Abo-Plan hinterlegt.");
            return;
          }
          payload.selling_plan = planId;
        }
        addBtn.disabled = true;
        addBtn.textContent = "Wird hinzugefügt …";
        window.FER.addToCart([payload], {
          onError: function () {
            window.alert("Das hat nicht geklappt. Bitte versuch es erneut.");
          },
        }).then(function () {
          addBtn.disabled = false;
          addBtn.textContent = section.getAttribute("data-add-label") || "In den Warenkorb";
        });
      });
    }

    refresh();
  });

  /* ---------- ferkosten: flavor toggle (supports any number of flavor blocks) ---------- */
  document.querySelectorAll("[data-taste-page]").forEach(function (page) {
    var inputs = page.querySelectorAll('input[name="fer-taste-flavor"]');
    var showFor = page.querySelectorAll("[data-show-for]");
    var showForFlavor = page.querySelectorAll("[data-show-for-flavor]");
    var moodTargets = page.hasAttribute("data-mood")
      ? [page].concat(Array.prototype.slice.call(page.querySelectorAll("[data-mood]")))
      : Array.prototype.slice.call(page.querySelectorAll("[data-mood]"));
    var defaultMood = page.getAttribute("data-default-mood") || "chapter-mixed";
    var moodMap = {};
    try {
      moodMap = JSON.parse(page.getAttribute("data-mood-map") || "{}");
    } catch (e) {
      moodMap = {};
    }

    function apply() {
      var checked = page.querySelector('input[name="fer-taste-flavor"]:checked');
      var value = checked ? checked.value : null;
      showFor.forEach(function (el) {
        el.hidden = el.getAttribute("data-show-for") !== value;
      });
      showForFlavor.forEach(function (el) {
        el.hidden = value ? el.getAttribute("data-show-for-flavor") !== value : false;
      });
      var mood = (value && moodMap[value]) || defaultMood;
      moodTargets.forEach(function (el) {
        Object.keys(moodMap).forEach(function (key) {
          el.classList.remove(moodMap[key]);
        });
        el.classList.remove(defaultMood);
        el.classList.add(mood);
      });
    }
    inputs.forEach(function (i) { i.addEventListener("change", apply); });
    apply();
  });

})();
